export default __webpack_public_path__ + "static/media/Rectangle_bg_1.2df67d62.png";